import { Box } from '@mui/material';
import { Bone } from '../../../../../../../../components/ui/DashboardSkeletons';

interface LoadingSpinnerProps {
  /** Kept for older callers; the placeholder sizes itself. */
  size?: number;
  /** What is loading, read out to screen readers ("Loading settings..."). */
  message?: string;
  minHeight?: number;
}

/**
 * The settings and Design loading state: a dark placeholder shaped like a
 * page of fields (a heading, a few rows, a larger block), so the content
 * fades in where it was instead of popping in behind a spinner. The name is
 * kept so existing callers need no change.
 */
export function LoadingSpinner({ message, minHeight = 240 }: LoadingSpinnerProps) {
  return (
    <Box
      role="status"
      aria-busy="true"
      aria-label={message || 'Loading'}
      sx={{
        flex: 1,
        minHeight,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        p: 2
      }}
    >
      <Bone width={180} height={20} />
      <Bone width="70%" height={14} />
      <Bone height={44} sx={{ mt: 1 }} />
      <Bone height={44} />
      <Bone height={Math.max(60, minHeight - 200)} radius="8px" />
    </Box>
  );
}
